const CustomerStoresView = ({ data }) => {
  const customer = data.customer;
  const reportData = customer.reportData ? JSON.parse(customer.reportData) : {};
  const storesByYear = (reportData.salesBudgets || [])
    .map((item) => ({
      year: Number(item.year),
      numberOfStores: Number(item.numberOfStores || 0),
    }))
    .sort((a, b) => a.year - b.year);

  return (
    <div className="card">
      <h5>Stores</h5>
      {storesByYear.length === 0 ? (
        <div className="mt-2 text-sm opacity-70">No stores.</div>
      ) : (
        <div className="mt-2 -mx-1">
          <div className="font-code">
            <table className="with-border">
              <thead>
                <tr>
                  <th>Year</th>
                  <th className="text-right">Number of Stores</th>
                </tr>
              </thead>
              <tbody>
                {storesByYear.map((item) => (
                  <tr key={item.year}>
                    <td>{item.year}</td>
                    <td className="text-right">
                      {item.numberOfStores.toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerStoresView;
